import { FunctionComponent, h } from 'preact';
import { AppRouter } from './routers/app-router';
import ErrorBoundary from './components/error-boundary/error-boundary';

export const App: FunctionComponent = () => {
	return (
		<ErrorBoundary>
			<AppRouter />
		</ErrorBoundary>
	);
};
